
import {
  defineAsyncComponent,
  defineComponent,
  PropType,
  SetupContext,
  ref,
  watch,
} from 'vue';

/** Interfaces */
import { NegotiationsI } from '@/interfaces/general.interface';

/** Composables */
import { usePaymentCard } from '@/composition/usePaymentCard';
import { ObligationTypes } from '@/utils/multi-pdf-types';

export default defineComponent({
  name: 'NegotiationCard',
  components: {
    Tooltips: defineAsyncComponent(
      () => import('@/components/shared/Tooltips.vue')
    ),
    Loader: defineAsyncComponent(
      () => import('@/components/loader/Loader.vue')
    ),
  },
  props: {
    negotiations: {
      type: Array as PropType<NegotiationsI[]>,
      required: true,
    },
    isLoadingPaymentStatus: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['view-detail-plan', 'make-payment'],
  setup(_props, context: SetupContext) {
    const obligationType = ObligationTypes.NEGOTIATION;
    const {
      bindClassState,
      hiddenPartialData,
      viewDetailPlan,
      makePayment,
      hasBussiness,
      getReference,
      canMakePayment,
      getLastPaymentStatus,
    } = usePaymentCard(context);

    const openState = ref<Record<string, boolean>>({});

    const initOpenState = () => {
      _props.negotiations.forEach((n) => {
        openState.value[n.register_type_id] = true;
      });
    };

    const isOpen = (id: string): boolean => openState.value[id] ?? true;

    const toggleAccordion = (id: string): void => {
      openState.value[id] = !isOpen(id);
    };

    initOpenState();

    watch(
      () => _props.negotiations,
      () => initOpenState(),
      { deep: true }
    );

    return {
      bindClassState,
      hiddenPartialData,
      viewDetailPlan,
      makePayment,
      hasBussiness,
      obligationType,
      getReference,
      canMakePayment,
      getLastPaymentStatus,
      isOpen,
      toggleAccordion,
    };
  },
});
